module.exports = __webpack_public_path__ + "static/img17-1278225b7bd44b2cd77a0f8905ce4721.jpg";